export const GET_CONTACT_US_SETUP = "GET_CONTACT_US_SETUP"
export const GET_CONTACT_US_SETUP_SUCCESS = "GET_CONTACT_US_SETUP_SUCCESS"
export const GET_CONTACT_US_SETUP_FAILED = "GET_CONTACT_US_SETUP_FAILED"

export const GET_USER_LIST = "GET_USER_LIST"
export const GET_USER_LIST_SUCCESS = "GET_USER_LIST_SUCCESS"
export const GET_USER_LIST_FAILED = "GET_USER_LIST_FAILED"
export const RESET_USER_LIST = "RESET_USER_LIST"

export const OPEN_SELECT_USERS_MODAL = "OPEN_SELECT_USERS_MODAL"
export const HIDE_SELECT_USERS_MODAL = "HIDE_SELECT_USERS_MODAL"

export const UPDATE_CONTACT_US_SETUP = "UPDATE_CONTACT_US_SETUP"
export const UPDATE_CONTACT_US_SETUP_SUCCESS = "UPDATE_CONTACT_US_SETUP_SUCCESS"
export const UPDATE_CONTACT_US_SETUP_FAILED = "UPDATE_CONTACT_US_SETUP_FAILED"

export const UPDATE_CONTACT_DATA = "UPDATE_CONTACT_DATA"
export const UPDATE_CONTACT_DATA_SUCCESS = "UPDATE_CONTACT_DATA_SUCCESS"
export const UPDATE_CONTACT_DATA_FAILED = "UPDATE_CONTACT_DATA_FAILED"
